import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getPartsAllList } from '../partsThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'partsAllList';

export const partsAllListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getPartsAllList });
    },
});

export const partsAllList = partsAllListSlice.reducer;
